var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('layout-error',[_c('card-error',{attrs:{"error_on_back":_vm.$t('messages.errors.not_found.error_on_back'),"message":_vm.$t('messages.errors.not_found.message')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }